import React, { useCallback, useEffect, useRef, useState } from 'react';
import {
  FiUser,
  FiArrowLeftCircle,
  FiArrowRightCircle,
} from 'react-icons/fi';
import { Form } from '@unform/web';
import { FormHandles } from '@unform/core';
import * as Yup from 'yup';

import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from '../../../hooks/useTranslation';

import getValidationErrors from '../../../utils/getValidationErrors';

import Input from '../../../components/Input';
import Button from '../../../components/Button';

import { config } from '../../../config';

import {
  Container,
  ContainerStep,
  Content,
  AnimationContainer,
  Title,
  ColInput,
} from './styles';

import {
  customerClear,
  customerStepRequest,
  customerCreateRequest,
} from '../../../store/modules/auth/actions';
import {
  AuthActionStep,
  CustomerData,
} from '../../../store/modules/auth/types';

import { viewModal } from '../../../store/modules/parameter/actions';
import { StoreState } from '../../../store/createStore';
import SignUpStep01 from '../SignUpStep01';
import SignUpStep03 from '../SignUpStep03';
import Checkbox from '../../../components/Checkbox';
import AgreementsModal from '../../../components/AgreementsModal';

const SignUpStep02: React.FC = () => {
  const { onTranslation: t } = useTranslation();

  const [checked, setChecked] = useState(false);
  const formRef = useRef<FormHandles>(null);
  const dispatch = useDispatch();
  const {
    step,
    userCreate,
    loading
  } = useSelector((state: StoreState) => state.auth);
  const [viewAgreementModal, setViewAgreementModal] = useState(false);

  const handleSubmit = useCallback(async (data: CustomerData) => {
    try {
      if (loading) return;
      formRef.current?.setErrors({});
      const schema = Yup.object().shape({
        password: Yup.string().required(t('main.messages_yup.password_required')),
        password_confirm: Yup.string()
          .required(t('main.messages_yup.password_required'))
          .min(6, `${t('main.messages_yup.min')} 6 ${t('main.messages_yup.digits')}`)
          .oneOf([Yup.ref('password')], 'As senhas devem ser iguais'),
      });

      await schema.validate(data, {
        abortEarly: false,
      });

      const customerData: CustomerData = {
        ...userCreate,
        password: data.password,
        password_confirm: data.password_confirm,
      };
      dispatch(customerCreateRequest(customerData, AuthActionStep.CST_STEP_04, undefined, t('main.modal_signup.signupstep02.signupSuccess'), t('main.modal_signup.signupstep02.signupError')));
    } catch (error) {
      if (error instanceof Yup.ValidationError) {
        const errors = getValidationErrors(error);
        formRef.current?.setErrors(errors);
        //konsole.log('handleSubmit errors:', errors);
      }
    }
  }, [dispatch, userCreate, t, loading]);

  const handleStep = useCallback(() => {
    dispatch(customerStepRequest(AuthActionStep.CST_STEP_02));
    dispatch(viewModal(SignUpStep01, { width: '50%', height: '80%' }));
  }, [dispatch]);

  useEffect(() => {
    if (step === 'CST_STEP_04') {
      dispatch(customerClear());
      dispatch(viewModal(SignUpStep03, { width: '50%', height: '80%' }));
    }
  }, [step, dispatch]);

  const handleChecked = useCallback((e) => {
    //konsole.log("SignUpStep02: e", e.currentTarget.value);
    setChecked(e.currentTarget.checked);

  }, []);

  const handledViewAgreementModal = () => {
    setViewAgreementModal(v => !v);
  }

  if (viewAgreementModal) {
    return (
      <AgreementsModal onCloseModal={handledViewAgreementModal} />
    )
  }

  return (
    <Container>
      <Content>
        <AnimationContainer>
          <ContainerStep>
            <FiArrowLeftCircle
              size={36}
              color="var(--primary)"
              onClick={handleStep}
            />
            <img src={config.logo} alt="ConectoVarejo" />
            <FiArrowRightCircle size={36} color="var(--primary)" />
          </ContainerStep>

          <Form
            // initialData={{
            //   password: '123456789',
            //   password_confirm: '123456789',
            // }}
            ref={formRef}
            onSubmit={handleSubmit}
          >
            <Title>
              <span>{t('main.modal_signup.signupstep02.title')}</span>
            </Title>

            <ColInput>
              <div style={{ marginBottom: '30px' }} />
            </ColInput>

            <ColInput>
              <Input
                icon={FiUser}
                type="password"
                name="password"
                placeholder={t('main.modal_signup.signupstep02.input_password')}
              />
              <Input
                icon={FiUser}
                type="password"
                name="password_confirm"
                placeholder={t('main.modal_signup.signupstep02.input_confirm_password')}
              />
            </ColInput>
            <ColInput>
              <div style={{ margin: '30px 0' }}>
                <Checkbox
                  name="agreement"
                  handleChecked={handleChecked}
                  options={[
                    {
                      id: 'yes',
                      label: t('main.modal_signup.signupstep02.terms_of_use_label'),
                      titleButtonClick: t('main.modal_signup.signupstep02.terms_of_use_button'),
                      buttonClick: handledViewAgreementModal
                    }
                  ]}
                />
              </div>
            </ColInput>

            <ColInput>
              <Button
                button={{ type: checked ? 'submit' : 'button' }}
                atributes={{
                  buttonType: checked ? 'primary' : 'disabled',
                  textColor: '#fff',
                  textSize: '30px',
                  borderColor: '#dddddd',
                }}
              >
                {t('main.modal_signup.button_signup')}
              </Button>
            </ColInput>
          </Form>
        </AnimationContainer>
      </Content>
    </Container>
  );
};

export default SignUpStep02;
